type Props = {
  children: React.ReactNode;
};

const ErrorMessage: React.FunctionComponent<Props> = ({ children }) => {
  return <p className="mt-1 text-sm text-red-600">{children}</p>;
};

export default ErrorMessage;
